import { render, staticRenderFns } from "./BilledServices.vue?vue&type=template&id=282e6d40&scoped=true"
import script from "./BilledServices.vue?vue&type=script&lang=js"
export * from "./BilledServices.vue?vue&type=script&lang=js"
import style0 from "./BilledServices.vue?vue&type=style&index=0&id=282e6d40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282e6d40",
  null
  
)

export default component.exports